import { useState } from 'react'
import { phoneNumberClickedEvent } from 'lib/services/gtm'
import styles from './PhoneNumber.module.scss'

export default function PhoneNumber({ number, owner }) {
  const [desktopText, setDesktopText] = useState('Näytä numero')

  const doAnalytics = () => {
    phoneNumberClickedEvent(number, owner)
  }

  const showDesktopNumber = () => {
    doAnalytics()
    setDesktopText(number)
  }

  return (
    <>
      <a className={styles.mobile} onClick={doAnalytics} href={`tel:${number}`}>
        <img
          className={styles.phoneIcon}
          src="/img/phone.svg"
          alt=""
          role="presentation"
          width="16"
          height="16"
          loading="lazy"
        />
        {number}
      </a>
      <div className={styles.desktop} onClick={showDesktopNumber}>
        <img
          className={styles.phoneIcon}
          src="/img/phone.svg"
          alt=""
          role="presentation"
          width="16"
          height="16"
          loading="lazy"
        />
        {desktopText}
      </div>
    </>
  )
}
